import React from 'react';

const Destination: React.FC = () => {
    return (
        <>
      
        </>
    );
}

export default Destination;